import ErrorBug from 'components/errors/bugs'
import AccountLayout from 'layout/account/accountLayout'
import { RouteObject } from 'react-router-dom'
import AuthNationalCode from '.'

export const authNationalCode: RouteObject[] = [
    {
        path: '/authentication_with_national_code',
        element: <AccountLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: '',
                element: <AuthNationalCode />,
            },
        ],
    },
]
